import React from 'react';

const ClusterMarker = ({ pointCount }) => (
  <div className='list-map__cluster-marker'>
    {pointCount}
  </div>
);

export default ClusterMarker;
